import React from 'react'
import { InputAdornment, TextField } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import T from 'prop-types'

export default function SearchField(props) {
  return (
    <TextField
      size="small"
      fullWidth
      {...props}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <SearchIcon />
          </InputAdornment>
        ),
        ...props?.InputProps,
      }}
      // sx={{ width: 1, ...props?.sx }}
    />
  )
}

SearchField.propTypes = {
  label: T.string,
  value: T.string,
  handleChangeSearch: T.func,
}
